module.exports = __webpack_public_path__ + "static/media/waiting-patients.cde094d8.svg";